// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 250px;\n}\n\n:host ::ng-deep .message > button {\n  margin-top: 35px;\n}\n\n.message > i {\n  color: #017097;\n  font-size: 43px;\n}\n\n.message > span {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
